import React from 'react';
import ResourceLayout from './ResourceLayout';

const CourseOutlineTemplate = () => {
  const content = (
    <div className="space-y-8 print:space-y-6">
      <div className="bg-gradient-card p-6 rounded-lg border print:border-gray-300 print:bg-white">
        <h2 className="text-2xl font-bold text-primary mb-4 print:text-black">Course Information</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 print:grid-cols-2 print:gap-4">
          <div className="space-y-3 print:space-y-2">
            <div>
              <label className="block text-sm font-semibold text-foreground mb-1 print:text-black">Course Title:</label>
              <div className="border-b border-muted-foreground/30 pb-1 min-h-[24px] print:border-black print:pb-2"></div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-foreground mb-1 print:text-black">Course Duration:</label>
              <div className="border-b border-muted-foreground/30 pb-1 min-h-[24px] print:border-black print:pb-2"></div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-foreground mb-1 print:text-black">Target Audience:</label>
              <div className="border-b border-muted-foreground/30 pb-1 min-h-[24px] print:border-black print:pb-2"></div>
            </div>
          </div>
          <div className="space-y-3 print:space-y-2">
            <div>
              <label className="block text-sm font-semibold text-foreground mb-1 print:text-black">Instructor:</label>
              <div className="border-b border-muted-foreground/30 pb-1 min-h-[24px] print:border-black print:pb-2"></div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-foreground mb-1 print:text-black">Prerequisites:</label>
              <div className="border-b border-muted-foreground/30 pb-1 min-h-[24px] print:border-black print:pb-2"></div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-foreground mb-1 print:text-black">PD Hours:</label>
              <div className="border-b border-muted-foreground/30 pb-1 min-h-[24px] print:border-black print:pb-2"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border print:border-gray-300 print:bg-white">
        <h2 className="text-2xl font-bold text-primary mb-4 print:text-black">Course Description</h2>
        <div className="space-y-4 print:space-y-3">
          <div>
            <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Overview:</label>
            <div className="border border-muted-foreground/30 rounded p-3 min-h-[80px] print:border-black print:min-h-[60px]"></div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Course Objectives:</label>
            <div className="space-y-2 print:space-y-1">
              {[1, 2, 3, 4].map((num) => (
                <div key={num} className="flex items-center space-x-2">
                  <span className="text-primary font-semibold">{num}.</span>
                  <div className="border-b border-muted-foreground/30 pb-1 flex-1 min-h-[24px]"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border print:border-gray-300 print:bg-white">
        <h2 className="text-2xl font-bold text-primary mb-4 print:text-black">Course Modules</h2>
        <div className="space-y-6 print:space-y-4">
          {[1, 2, 3, 4].map((moduleNum) => (
            <div key={moduleNum} className="border border-muted-foreground/20 rounded-lg p-4 print:border-gray-300 print:p-3">
              <div className="flex items-center space-x-3 mb-3 print:mb-2">
                <div className="bg-primary text-primary-foreground rounded-full w-8 h-8 flex items-center justify-center font-bold print:bg-black print:text-white">
                  {moduleNum}
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-semibold text-foreground mb-1 print:text-black">Module Title:</label>
                  <div className="border-b border-muted-foreground/30 pb-1 min-h-[24px] print:border-black print:pb-2"></div>
                </div>
                <div className="w-24">
                  <label className="block text-sm font-semibold text-foreground mb-1 print:text-black">Duration:</label>
                  <div className="border-b border-muted-foreground/30 pb-1 min-h-[24px] print:border-black print:pb-2"></div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 print:grid-cols-2 print:gap-3">
                <div>
                  <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Learning Objectives:</label>
                  <div className="border border-muted-foreground/30 rounded p-2 min-h-[60px] print:border-black print:min-h-[50px]"></div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Activities & Resources:</label>
                  <div className="border border-muted-foreground/30 rounded p-2 min-h-[60px] print:border-black print:min-h-[50px]"></div>
                </div>
              </div>
              <div className="mt-3 print:mt-2">
                <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Assessment Methods:</label>
                <div className="border border-muted-foreground/30 rounded p-2 min-h-[40px] print:border-black print:min-h-[30px]"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border print:border-gray-300 print:bg-white">
        <h2 className="text-2xl font-bold text-primary mb-4 print:text-black">Assessment & Evaluation</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 print:grid-cols-2 print:gap-4">
          <div>
            <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Formative Assessments:</label>
            <div className="border border-muted-foreground/30 rounded p-3 min-h-[80px] print:border-black print:min-h-[60px]"></div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Summative Assessments:</label>
            <div className="border border-muted-foreground/30 rounded p-3 min-h-[80px] print:border-black print:min-h-[60px]"></div>
          </div>
        </div>
        <div className="mt-4 print:mt-3">
          <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Success Metrics:</label>
          <div className="border border-muted-foreground/30 rounded p-3 min-h-[60px] print:border-black print:min-h-[50px]"></div>
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border print:border-gray-300 print:bg-white">
        <h2 className="text-2xl font-bold text-primary mb-4 print:text-black">Resources & Materials</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 print:grid-cols-2 print:gap-4">
          <div>
            <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Required Materials:</label>
            <div className="border border-muted-foreground/30 rounded p-3 min-h-[80px] print:border-black print:min-h-[60px]"></div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Technology Requirements:</label>
            <div className="border border-muted-foreground/30 rounded p-3 min-h-[80px] print:border-black print:min-h-[60px]"></div>
          </div>
        </div>
        <div className="mt-4 print:mt-3">
          <label className="block text-sm font-semibold text-foreground mb-2 print:text-black">Additional Resources:</label>
          <div className="border border-muted-foreground/30 rounded p-3 min-h-[60px] print:border-black print:min-h-[50px]"></div>
        </div>
      </div>
    </div>
  );

  return (
    <ResourceLayout
      title="Course Outline Template"
      description="A comprehensive template for planning and structuring your professional development courses"
      content={content}
    />
  );
};

export default CourseOutlineTemplate;